import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

/**
 * Generate a multi-page PDF from an InvoiceLayout-like container element.
 * The container should contain one element with class `page-break-after` (the bill header)
 * followed by one or more elements with class `page-break-before` (bookings pages).
 *
 * @param {HTMLElement} container - DOM node containing the rendered InvoiceLayout
 * @param {string} filename - filename to save (without extension)
 */
export async function generatePdfFromInvoiceLayout(container, filename = 'Invoice') {
  if (!container) throw new Error('Container element is required');

  const page1 = container.querySelector('.page-break-after');
  const bookingPages = container.querySelectorAll('.page-break-before');

  if (!page1) throw new Error('Invoice layout missing page-break-after element');

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const a4Width = 210;

  // Render page 1
  const canvas1 = await html2canvas(page1, {
    scale: 1.5,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    allowTaint: true,
    foreignObjectRendering: false
  });

  const imgData1 = canvas1.toDataURL('image/jpeg', 0.8);
  const imgHeight1 = (canvas1.height * a4Width) / canvas1.width;
  pdf.addImage(imgData1, 'JPEG', 0, 0, a4Width, imgHeight1);

  // Render subsequent booking pages
  for (let i = 0; i < bookingPages.length; i++) {
    const el = bookingPages[i];
    const canvas = await html2canvas(el, {
      scale: 1.5,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      allowTaint: true,
      foreignObjectRendering: false
    });
    const img = canvas.toDataURL('image/jpeg', 0.8);
    const imgHeight = (canvas.height * a4Width) / canvas.width;
    pdf.addPage();
    pdf.addImage(img, 'JPEG', 0, 0, a4Width, imgHeight);
  }

  pdf.save(`${filename}.pdf`);
}
